module.exports = require('jadelet').exec(["button",{"click":{"bind":"cancel"}},["Cancel"]]);